import { Box, LinearProgress, setRef, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { capitalizeFirstLetter, formatBytes } from "utils/utils";
import CrossIcon from "assets/Icons/replenishment/CrossIcon.svg";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { EXCEL_MEDIA_TYPE } from "components/Table/constants";
import { apiClient } from "api";
import _ from "lodash";
import { useDispatch } from "react-redux";
import { addRangerBulkCalculatedData } from "store/ranger/ranger.slice";

const FileBox = ({
  widgetName,
  data,
  removeFile,
  stopUpload,
  startUpload,
  response,
  files,
  fileChanged,
}: {
  widgetName?: string;
  data: File;
  removeFile: (name: string) => void;
  startUpload?: boolean;
  stopUpload?: boolean;
  response?: any;
  files: File[];
  fileChanged: boolean;
}) => {
  const dispatch = useDispatch();
  const [incomingResponse, setIncomingResponse] = useState<any>("");
  const [error, setError] = useState<any>("");

  // !TODO: on unmount remove existing response
  useEffect(() => {
    return () => {
      setIncomingResponse("");
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(response)) {
      if (response?.data?.fba_measurement_details) {
        dispatch(
          addRangerBulkCalculatedData(
            response?.data?.fba_measurement_details?.map(
              (item: any, id: number) => ({ ...item, Id: item.id, id })
            )
          )
        );
      } else if (response?.data?.fulfilment_fee_calculator_details) {
        dispatch(
          addRangerBulkCalculatedData(
            response?.data?.fulfilment_fee_calculator_details?.map(
              (item: any, id: number) => ({ ...item, id })
            )
          )
        );
      }
      setIncomingResponse(response);
    }
  }, [response]);

  return (
    <Box
      sx={{
        background: "rgba(25, 118, 210, 0.12);",
        borderRadius: "4px",
        width: "93%",

        margin: "8px",
        padding: "9px",
        position: "relative",
      }}
    >
      <Box
        sx={{
          cursor: "pointer",
          position: "absolute",
          right: "12px",
          top: "12px",
        }}
        onClick={() => {
          removeFile(data.name);
        }}
      >
        <img src={CrossIcon} alt="cross" />
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        <Typography
          sx={{
            fontSize: "14px",
            fontWeight: "400",
            fontFamily: "Lato",
            color: "#002B49",
          }}
        >
          {data?.name}
        </Typography>
        <Typography
          sx={{
            fontSize: "10px",
            fontWeight: "400",
            fontFamily: "Lato",
            color: "#002B49",
            marginTop: "4px",
          }}
        >
          {formatBytes(data.size)}
        </Typography>
        {startUpload && <LinearProgress sx={{ margin: "20px 0" }} />}
      </Box>
      {incomingResponse &&
        (incomingResponse?.data?.fba_dimension_improvement_details ||
          incomingResponse?.data?.fba_measurement_details ||
          incomingResponse?.data?.fulfilment_fee_calculator_details ||
          incomingResponse === "File successfully uploaded!") && (
          <Box
            sx={{ display: "flex", alignItems: "center", marginTop: "12px" }}
          >
            <CheckCircleOutlineIcon
              sx={{
                color: "green",
                marginRight: "4px",
                marginTop: "2px",
                width: "14px",
                height: "14px",
              }}
            />
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "Lato",
                color: "green",
              }}
            >
              {"File upload success!"}
            </Typography>
          </Box>
        )}
      {incomingResponse && (
        <Box style={{ display: "flex", flexDirection: "column" }}>
          <Box
            style={{ display: "flex", alignItems: "center", marginTop: "15px" }}
          >
            {incomingResponse.data !== null &&
            !incomingResponse.data?.fba_dimension_improvement_details &&
            !incomingResponse.data?.fba_measurement_details &&
            !incomingResponse.data?.fulfilment_fee_calculator_details ? (
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: "400",
                  fontFamily: "Lato",
                  color: "green",
                }}
              >
                {incomingResponse.data}
                {incomingResponse.data &&
                  widgetName === "mismatchSummary" &&
                  ". Please wait a few minutes for the uploaded data to reflect."}
              </Typography>
            ) : (
              incomingResponse.errors?.message && (
                <Box sx={{ display: "flex", flexDirection: "column" }}>
                  <p
                    style={{
                      fontSize: "14px",
                      fontWeight: "400",
                      fontFamily: "Lato",
                      color: "rgba(211, 47, 47, 1)",
                      marginTop: "5px",
                      // marginLeft: "17px",
                    }}
                  >
                    The report uploaded has some errors!
                  </p>
                  <Typography
                    sx={{
                      fontSize: "14px",
                      fontWeight: "400",
                      fontFamily: "Lato",
                      color: "rgba(211, 47, 47, 1)",
                    }}
                  >
                    {incomingResponse.errors?.message &&
                      //@ts-ignore
                      capitalizeFirstLetter(incomingResponse.errors.message)}
                  </Typography>
                </Box>
              )
            )}
          </Box>
          {incomingResponse.error && (
            <Typography
              sx={{
                fontSize: "14px",
                fontWeight: "400",
                fontFamily: "Lato",
                color: "rgba(211, 47, 47, 1)",
              }}
            >
              {
                //@ts-ignore
                typeof incomingResponse.error !== "string"
                  ? `${
                      incomingResponse.error[0]?.loc[0] &&
                      capitalizeFirstLetter(incomingResponse.error[0]?.loc[0])
                    }: ${incomingResponse.error[0]?.msg}`
                  : incomingResponse.error
              }
            </Typography>
          )}
          {incomingResponse?.data === null &&
          typeof incomingResponse?.errors !== "string" ? (
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <p
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  fontFamily: "Lato",
                  color: "rgba(211, 47, 47, 1)",
                  marginTop: "5px",
                  // marginLeft: "17px",
                  cursor: "pointer",
                  textDecoration: "underline",
                }}
                onClick={() => {
                  const path = incomingResponse?.errors.download_link.replace(
                    "/",
                    ""
                  );
                  apiClient
                    .downloadErrorReportReplenishment(path)
                    .then((res: any) => {
                      const link = document.createElement("a");
                      link.href = EXCEL_MEDIA_TYPE + res;
                      link.setAttribute("download", "ErrorReport.xlsx"); //or any other extension
                      document.body.appendChild(link);
                      link.click();
                      document.body.removeChild(link);
                    })
                    .catch((err: Error) => console.log(err));
                }}
              >
                click here for full error report
              </p>
            </Box>
          ) : (
            <Box>
              <Typography
                style={{
                  fontSize: "12px",
                  fontWeight: "400",
                  fontFamily: "Lato",
                  color: "rgba(211, 47, 47, 1)",
                  marginTop: "5px",
                }}
              >
                {incomingResponse?.errors}
              </Typography>{" "}
            </Box>
          )}
        </Box>
      )}
    </Box>
  );
};

export default FileBox;
